module.exports = __webpack_public_path__ + "img/sv111.4560b2c6.svg";